import {
  styled,
  css,
  Breakpoints,
} from '@volkswagen-onehub/components-core';

interface AccordionWrapperProps {
  /** Targets elements within header portion of VW Accordion */
  headId: string;
  /** Targets elements within body portion of VW Accordion */
  bodyId: string;
}

export const AccordionWrapper = styled.div<AccordionWrapperProps>(
  ({ theme, headId, bodyId }) => css`
    & button#${headId} {
      padding: ${theme.size.static300} 0;

      @media (min-width: ${Breakpoints.b960}px) {
        padding: ${theme.size.static370} 0;
      }

      & svg {
        color: ${theme.colors.content.primary};
      }
    }

    & div#${bodyId} {
      padding-bottom: ${theme.size.dynamic0140};
      grid-template-columns: auto;
      display: grid;
    }

    & div#${bodyId}[aria-hidden='true'] {
      visibility: hidden;
      height: 0;
      padding: 0;
      display: block;
      overflow: hidden;
    }
  `
);
